import { ReactElement, useContext, useEffect } from "react";
import SettingsContext from "../contexts/SettingsContext";
import { useState } from "react";
import createIronSightsTarget from "./Play/GameUI/IronSights";
import Background from "./Play/Background/Background";

// type for props
type propsType = {
  abs: ReactElement | null;
  leftBound: number;
  rightBound: number;
  time: number;
};

/**
 * Renders a background of cubes
 * @returns a canvas with shooting cubes
 */
const FrenzyBackground = (props: propsType) => {
  const settingsContext = useContext(SettingsContext);
  const [targets, setTargets] = useState<ReactElement[]>([]); // targets to be rendered

  /**
   * Delay for a certain amount of time
   * @param time is the delay time
   * @returns after time
   */
  const delay = (time: number) => {
    return new Promise((resolve) => setTimeout(resolve, time));
  };

  // spawns targets infinitely
  useEffect(() => {
    setInterval(() => {
      setTargets((cur) => {
        const id = cur.length;
        cur = [...cur];
        const tar = createIronSightsTarget(
          settingsContext,
          id,
          props.leftBound,
          props.rightBound,
          () => {},
          () => {},
          () => {},
          () => {},
          -0.004,
          0.19,
          false
        );
        cur.push(tar);
        return cur;
      });
    }, props.time);
  }, []);

  return (
    <Background
      outer={
        <div className="w-full h-full flex justify-center items-center">
          {props.abs}
        </div>
      }
      inner={<>{targets.slice(-100)}</>}
      lives={false}
    />
  );
};

export default FrenzyBackground;
